export const GET_ALL_ROLE_PERMISSIONS = "GET_ALL_ROLE_PERMISSIONS"
export const SEARCH_ROLE_PERMISSION = "SEARCH_ROLE_PERMISSION"
export const GET_ROLE_PERMISSION = "GET_ROLE_PERMISSION"
export const ADD_ROLE_PERMISSION = "ADD_ROLE_PERMISSION"
export const UPDATE_ROLE_PERMISSION = "UPDATE_ROLE_PERMISSION"
export const DELETE_ROLE_PERMISSION = "DELETE_ROLE_PERMISSION"
